export const DISPLAY_TYPE_OPTIONS = [
  {
    value: 'story_block',
    label: 'Story block',
    description: 'Vertical scroll feed of full-width cards.',
    ready: true,
  },
  {
    value: 'carousel',
    label: 'Carousel',
    description: '3D deck of compact cards on desktop, swipe on mobile.',
    ready: true,
  },
  {
    value: 'grid',
    label: 'Grid',
    description: 'Responsive CSS grid of tiles.',
    ready: true,
  },
  {
    value: 'hero',
    label: 'Hero',
    description: 'Single viewport-sized card with arrows and dot indicators.',
    ready: true,
  },
  {
    value: 'circle_stories',
    label: 'Circle stories',
    description: 'Row of round avatars that open into a vertical viewer.',
    ready: true,
  },
  {
    value: 'floating_player',
    label: 'Floating player',
    description: 'Picture-in-picture tile that follows scroll.',
    ready: true,
  },
  {
    value: 'player_deck',
    label: 'Player deck',
    description: 'Fanned stack of cards revealed one at a time.',
    ready: true,
  },
  {
    value: 'horizontal_player',
    label: 'Horizontal player',
    description: 'Single wide card with a dominant play button.',
    ready: true,
  },
  {
    value: 'horizontal_carousel',
    label: 'Horizontal carousel',
    description: 'Row of three equal-width cards with snap scrolling.',
    ready: true,
  },
  {
    value: 'dynamic_carousel',
    label: 'Dynamic carousel',
    description: 'Asymmetric row - one featured card plus smaller thumbnails.',
    ready: true,
  },
  {
    value: 'vertical_stories',
    label: 'Vertical stories',
    description: 'Phone-shaped full-bleed vertical viewer.',
    ready: true,
  },
]
